import React, { useState } from 'react';
import styles from './verification-bottomsheet.module.scss';
import { BottomSheet, Button, Typography } from '@/ui-kit';
import { OkHandIcon, VerificationIcon } from '@/assets/icons';
import { useAuth } from '@/store/useAuth';
import WebApp from '@twa-dev/sdk';

interface Props {
    isVerificationModalOpen: boolean;
    setIsVerificationModalOpen: (val: boolean) => void;
    onOkClicked?: () => Promise<boolean>;
}

export const VerificationBottomsheet: React.FC<Props> = ({
    isVerificationModalOpen,
    setIsVerificationModalOpen,
    onOkClicked,
}) => {
    const userData =
        useAuth((state) => state.getUser());

    const handleBtnClick = async () => {
        if (onOkClicked) {
            const isSuccess = await onOkClicked?.()
            if (!isSuccess) return
        }
        const { id, public_name } = userData ?? {};
        const params = new URLSearchParams({
            text: `Привет! Хочу пройти верификацию. (${id}, ${public_name})`
        });

        WebApp.openTelegramLink(`https://t.me/euphora_support?${params}`);

        setIsVerificationModalOpen(false)
    }
    
    return (
        <BottomSheet
            isOpen={isVerificationModalOpen}
            isDeskorTop={false}
            onClose={() => setIsVerificationModalOpen(false)}>
            <div className={styles.verificationModalContent}>
                <VerificationIcon className={styles.verificationModalContentIcon} />
                <div className={styles.verificationModalContentHeader}>
                    <Typography
                        className={styles.verificationModalContentHeaderTitle}
                        variant={'h5'}
                        fontWeight={'bold'}>
                        Для верификации анкеты<br />отправь видео в поддержку
                    </Typography>
                    <Typography
                        className={styles.verificationModalContentHeaderDesc}>
                        Скажи на камеру: «Путешествия»<br />и покажи рукой так:
                    </Typography>
                    <OkHandIcon width={40} height={40} />
                </div>
                <div className={styles.verificationModalContentFootnote}>
                    <Typography
                        className={styles.verificationModalContentFootnoteTitle}>
                        Мы за честное и безопасное общение. Поэтому просим участников пройти простую верификацию.
                    </Typography>
                    <Typography
                        className={styles.verificationModalContentFootnoteSubtitle}>
                        Видео не передается третьим лицам и автоматически удаляется после проверки
                    </Typography>
                    <Button
                        typeColor="orange"
                        className={styles.verificationModalContentFootnoteBtn}
                        onClick={handleBtnClick}>
                        Окей
                    </Button>
                </div>
            </div>
        </BottomSheet>
    );
};
